import React from "react";
import {
  Box,
  Text,
  Heading,
  Image,
  Flex,
  Grid,
  
} from "@chakra-ui/react";
import service1 from "../../../assets/services/service1.jpg";
import service2 from "../../../assets/services/service2.jpg";
import service3 from "../../../assets/services/service3.jpg";
import flower from "../../../assets/services/SVG (1).png";
import flower1 from "../../../assets/services/SVG.png";
import FlowerImage from "component/FlowerImage";
import darkblue from '../../../assets/flower/dark blue.png'


const Service1 = () => {
  

  return (
    <>
    
    <Box
      bg="#F7F1E6"
      color="black"
      minH="65vh"
      display="flex"
      alignItems="center"
      px={{ base: 4, md: 16 }}
      position="relative"
    >
        <FlowerImage src={darkblue} top={{base:"67%" , md:"42%"}} left={{base:"65%" , md:"74%"}} width="30px" className="fade-in-up"/>
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
        w="100%"
        maxW="1200px"
        mx="auto"
        gap={8}
      >
        {/* Left: Text Section */}
        <Box
          flex="1"
          textAlign={{ base: "center", md: "left" }}
          mb={{ base: 6, md: 0 }}
        >
          <Heading fontSize={{ base: "2xl", md: "3xl" }} mb={4} className="fade-in-up">
            Doggle India
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} fontWeight="medium" mb={4} className="fade-in-up">
            Bringing the essence of Rajasthan, Marwadi wisdom, and digital
            expertise together.
          </Text>
          <Text fontSize={{ base: "sm", md: "md" }} color="gray.700" className="fade-in-up">
            Doggle India is here to take your business to new digital heights!
            If you want to make your brand stand out, we’ve got the perfect mix
            of creativity and strategy to make it happen.
          </Text>
        </Box>

        {/* Right: Image Section */}
        <Box
          flex="1"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
            gap={4}
            w="fit-content"
            position="relative"
          >
            {/* Image 1 */}
            <Box
              gridColumn={{ base: "auto", md: "2" }}
              gridRow={{ base: "1", md: "1" }}
            >
              <Image
                src={service1}
                alt="Teamwork"
                borderRadius="3xl"
                boxShadow="lg"
                w={{ base: "120px", md: "160px" }}
                h={{ base: "120px", md: "140px" }}
                objectFit="cover"
                className="fade-in-up"
              />
            </Box>

            {/* Image 2 */}
            <Box
              gridColumn="1"
              gridRow="1"
              zIndex="1"
              transform="translateY(30%)"
            >
              <Image
                src={service2}
                alt="Planning"
                borderRadius="3xl"
                boxShadow="lg"
                w={{ base: "140px", md: "180px" }}
                h={{ base: "140px", md: "160px" }}
                objectFit="cover"
                className="fade-in-up"
              />
            </Box>

            {/* Image 3 */}
            <Box gridColumn="2" gridRow="2" transform="translateX(-10%) " zIndex="2">
              <Image
                src={service3}
                alt="Development"
                borderRadius="3xl"
                boxShadow="lg"
                w={{ base: "120px", md: "180px" }}
                h={{ base: "120px", md: "180px" }}
                objectFit="cover"
                className="fade-in-up"
              />
            </Box>
          </Grid>
        </Box>
      </Flex>

      <Image
        src={flower}
        alt="Decorative Flower"
        position="absolute"
        top={{ base: "79%", md: "60%" }}
        left={{ base: "80%", md: "82%" }}
        w={{ base: "50px", md: "90px" }}
        h={{ base: "50px", md: "90px" }}
        className="fade-in-up"
      />
      <Image
        src={flower1}
        alt="Decorative Flower"
        position="absolute"
        top={{ base: "45%", md: "8%" }}
        right={{ base: "73%", md: "37%" }}
        w={{ base: "90px", md: "240px" }}
        h={{ base: "90px", md: "260px" }}
        className="fade-in-up"
      />
    </Box>
    </>
  );
};

export default Service1;
